import { Request } from 'api';
import { AxiosResponse } from 'axios';
import { DashboardCount } from 'utils';

type ReturnType = Promise<AxiosResponse<DashboardCount>>;

const getTrainDashboardCounts = (): ReturnType => {
    return Request.get(`analytics/train-dashboard`);
};

export default getTrainDashboardCounts;
